import React, { createContext, useContext, useState, useEffect } from 'react';

const OtherSectionsSearchContext = createContext();

let persistentState = {
  searchValue: '',
  searchResults: [],
  initialized: false
};

export const resetPersistentSearchState = () => {
  persistentState.searchValue = '';
  persistentState.searchResults = [];
  persistentState.initialized = false;
};

export const useOtherSectionsSearch = () => {
  const context = useContext(OtherSectionsSearchContext);
  if (!context) {
    throw new Error('useOtherSectionsSearch must be used within an OtherSectionsSearchProvider');
  }
  return context;
};

export const OtherSectionsSearchProvider = ({ children, sections }) => {
  const [searchValue, setSearchValue] = useState(persistentState.searchValue);
  const [searchResults, setSearchResults] = useState(
    persistentState.initialized ? persistentState.searchResults : [...sections]
  );

  useEffect(() => {
    if (!persistentState.initialized) {
      persistentState.searchResults = [...sections];
      persistentState.initialized = true;
    }
  }, [sections]);

  const updateSearchResults = (results) => {
    const newResults = [...results];
    setSearchResults(newResults);
    persistentState.searchResults = newResults;
  };

  const updateSearchValue = (value) => {
    setSearchValue(value);
    persistentState.searchValue = value;
  };

  const resetSearch = () => {
    const newValue = '';
    const newResults = [...sections];
    setSearchValue(newValue);
    setSearchResults(newResults);
    persistentState.searchValue = newValue;
    persistentState.searchResults = newResults;
  };

  const value = {
    searchValue,
    searchResults,
    updateSearchValue,
    updateSearchResults,
    resetSearch
  };

  return (
    <OtherSectionsSearchContext.Provider value={value}>
      {children}
    </OtherSectionsSearchContext.Provider>
  );
};
